import { render, staticRenderFns } from "./FaltantesRoundTrip.vue?vue&type=template&id=6e2d1246"
import script from "./FaltantesRoundTrip.vue?vue&type=script&lang=js"
export * from "./FaltantesRoundTrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports